<template>
  <div v-if="show" class="card-traffic">
    <div class="traffic_datepicker" >

      <span class="form-group">
        <WrapDatePicker
          type="date"
          value_type="X"
          v-model="cur_date"
          :range="true"
          format="X"
          :placeholder="translate('period')"
          :clearable="false"
        />
      </span>

      <div class="flex-item select">
        <tree-select
            :options="period_list"
            :multiple="false"
            v-model="selected_period"
            :placeholder="translate('period')"
            :clearable="false"
        />
      </div>

      <div class="flex-item select">
        <tree-select
            :options="params_list"
            :multiple="true"
            v-model="add_params"
            :placeholder="translate('gps_track.add_params.title')"
            :clearable="true"
        />
      </div>

      <div class="select">
        <div class="filter checkbox" v-if="$store.getters.getPermissions.permissionGod === true">
          <div class="info">
            {{ translate("traffic_conversion") }}
          </div>
          <label class="switch" @click.prevent="conversion = !conversion">
            <input type="checkbox" v-model="conversion">
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <button
          class="mdi btn btn-success"
          :class="{ 'mdi-content-save': !loading }"
          @click.prevent="save_traffic"
          :disabled="loading"
      >
        <scale-loader v-if="loading" height='9.5px' width='13.5px' margin='2px 2px 1px 2px'/>
        <span v-else> {{ translate('save') }} </span>

      </button>
    </div>

    <div v-if="tr.length <= 1 || noData === true" style="height: 100%">
      <h1 style="text-align: center" >
        {{translate('no_data')}}
      </h1>
    </div>

    <div v-else
      ref="header"
      class="response_table3"
    >
      <p class="title"> {{ translate("traffic_descr", { ed: conversion ? translate("traffic_unit_gb") : translate("traffic_unit_mb") }) }}</p>
      <p class="title" v-if="$store.getters.getPermissions.viewDeviceOverheadTraffic === true && filters.show_overhead"> {{ translate("traffic_descr_overhead") }} </p>
      <table
        ref="tabl"
        style="display: table; height: auto"
        @scroll="scroll"
      >
        <thead>
          <tr>
            <th
              rowspan="2"
              class="traffic_block"
            >
              {{ translate('date.one') }}
            </th>
            <th
              v-for="(item,index) in th"
              :key="index"
              colspan="3"
              class="traffic_block"
            >
              <div v-if="item.type===0">
                {{ item.name + (item.imsi?'('+item.imsi+')':'') }}
              </div>
              <div v-else>
                <span class="sphere" :style="'background-color:'+item.color" />
                {{ item.name + ' ' + (item.imsi?'('+item.imsi+')':'') + (item.slot? '(' + item.slot + ')' : '') }}
                <span v-if="+item.active === 1" class="mdi mdi-check-circle-outline" title="In device"></span>
                <span v-else class="mdi mdi-checkbox-blank-circle-outline" title="Not in device"></span>
              </div>
            </th>
          </tr>
          <tr>
            <template v-for="key in Object.keys(th)">
              <th :data-th="key">
                Rx ({{ traffic_unit }})
              </th>
              <th :data-th="key">
                Tx ({{ traffic_unit }})
              </th>
              <th :data-th="key" class="traffic_block" >
                Sum ({{ traffic_unit }})
              </th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, indx2) in display_tr"
            :key="indx2"
            :class="total.indexOf(item[0]) > -1 ? item[0] : '' "
          >
            <td
              v-for="(item2,index) in item"
              :key="index"
              :class="{traffic_block:(index%3===0)}"
            >
              {{ item2 }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div
    v-else
    style="height: 100%"
  >
    <div class="spinner">
      <scale-loader />
    </div>
  </div>
</template>

<script>
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";
import store from "@/Store/Store";

export default {
  name: 'Traffic',
  components:{
    WrapDatePicker
  },
  props: {
    dev_id: {
      type: [Number, String],
      default: null
    },
    simcard_list: {
      type: [Array, Object],
      default: () => []
    },
  },
  data () {
    let today = new Date().setHours(0, 0, 0, 0)
    let start = (new Date(today).setDate(new Date(today).getDate() - 6) / 1000)
    let end = (new Date(today).setHours(23, 59, 59, 0) / 1000)

    return {
      loading: false,
      show: false,
      noData: false,
      th: [],
      tr: [],
      today: today,
      date_end: end,
      date_start: start,
      cur_date: [''+start,''+end],
      add_params: [],
      total: ['summary', 'min', 'max', 'average'],
      selected_period: "week",
      conversion: this.$store.getters.getPermissions.permissionGod === true
    }
  },

  watch: {
    selected_period(){
      switch (this.selected_period) {
        case 'week':
          let today = new Date().setHours(0, 0, 0, 0)
          this.date_start = (new Date(today).setDate(new Date(today).getDate() - 6) / 1000)
          this.date_end = (new Date(today).setHours(23, 59, 59, 0) / 1000)
          this.cur_date = [String(this.date_start),String(this.date_end)]
          break
        case 'cur_month':
          this.date_start = (new Date(this.today).setDate(1) / 1000)
          this.date_end = (new Date(this.today).setHours(23, 59, 59, 0) / 1000)
          this.cur_date = [String(this.date_start),String(this.date_end)]
          break
        case 'last_30_days':
          this.date_start = (new Date(this.today).setMonth(new Date(this.today).getMonth() - 1) / 1000)
          this.date_end = (new Date(this.today).setHours(23, 59, 59, 0) / 1000)
          this.cur_date = [String(this.date_start),String(this.date_end)]
          break
        default:
          const dates = String(this.selected_period).split(" - ");
          const date_start = dates[0].split("-")
          const date_end = dates[1].split("-")
          this.date_start = new Date(Number(date_start[2]), Number(date_start[1]) - 1, Number(date_start[0])).setHours(0, 0, 0, 0) / 1000
          this.date_end = new Date(Number(date_end[2]), Number(date_end[1]) - 1, Number(date_end[0])).setHours(0, 0, 0, 0) / 1000
          this.cur_date = [String(this.date_start),String(this.date_end)]
          break
      }
    },
    dev_id () {
      this.get_traffic()
    },
    cur_date () {
      if (this.cur_date.length > 1) {
        let start = new Date(+this.cur_date[0] * 1000)
        let end = new Date(+this.cur_date[1] * 1000)
        this.date_start = start.setHours(0, 0, 0, 0) / 1000
        this.date_end =  end.setHours(23, 59, 59, 0) / 1000
        this.get_traffic()
      }
    },
    "filters":{
      deep: true,
      handler: function () {
        this.get_traffic()
      },
    },
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },

  mounted () {
    this.add_params = this.$store.getters.getPermissions.permissionGod === true ? ["summary"] : []
    this.get_traffic()
  },

  computed:{
    traffic_unit() {
      return this.conversion ? 'GB' : 'MB'
    },

    display_tr() {
      if (!this.conversion) {
        return this.tr
      }

      return this.tr.map(row => {
        return row.map((value, index) => {
          if (index === 0) {
            return value
          }

          if (value === 'null' || value === null || value === undefined) {
            return value
          }

          return (Number(value) / 1024).toFixed(2)
        })
      })
    },
    period_list(){
      let periods = [
        {id: "week", label: this.translate("traffic_period.week")},
        {id: "cur_month", label: this.translate("traffic_period.cur_month")},
        {id: "last_30_days", label: this.translate("traffic_period.last_30_days")}
      ]

      let today = new Date().setHours(0, 0, 0, 0)
      let this_month = new Date(today).getMonth()

      today = new Date(today).setDate(1)
      for (let i = 1; i <= 12; i++) {
        let date = new Date(today).setMonth(this_month - i)
        let last_day_last_month = new Date(today).setMonth(this_month - i + 1, 0)
        let string1 = `${("0" + (new Date(date).getDate())).slice(-2)}-${("0" + (new Date(date).getMonth() + 1)).slice(-2)}-${new Date(date).getFullYear()}`
        let string2 = `${("0" + (new Date(last_day_last_month).getDate())).slice(-2)}-${("0" + (new Date(last_day_last_month).getMonth() + 1)).slice(-2)}-${new Date(last_day_last_month).getFullYear()}`
        periods.push({id: `${string1} - ${string2}`, label: `${string1} - ${string2}`})
      }
      return periods
    },
    datetime_picker(){
      return this.$store.getters.getDatetimePicker
    },
    params_list(){
      let params = [
        { id: "utc", label: this.translate('use_utc_time') },
      ]
      if (this.$store.getters.getPermissions.permissionGod === true){
        let params_god = [
          { id: "summary", label: "Summary" },
          { id: "show_overhead", label: this.translate('show_overhead') },
          { id: "group_by_country", label: this.translate('group_by_country')}
        ]
        params = params.concat(params_god)
      }
      if (this.$store.getters.getPermissions.viewDeviceAllIfacesTraffic === true){
        params = params.concat([{ id: "all_ifaces", label: this.translate('all_ifaces') }])
      }

      return params
    },
    filters(){
      let result = {}
      for (let param of this.add_params) {
        result[param] = true
      }
      return result
    }
  },
  methods: {
    find_sim_by_imsi(imsi){
      for (let simcard of this.simcard_list) {
        if (simcard.imsi === imsi) {
          return simcard
        }
      }
    },

    disabledDate(date) {
      let today = new Date();
      return date > new Date(today.getTime()) || date < new Date(today.getTime() - this.datetime_picker * 24 * 3600 * 1000);
    },

    scroll (event) {
      this.$refs.header.scrollTo(event.target.scrollLeft, 0)
    },

    save_traffic () {
      this.loading = true;
      let params = {
        ...this.filters,
        start: this.date_start,
        end: this.date_end,
        csv: true,
      }
      this.$http.v1.getDeviceTraffic(this.dev_id, params, (response) => {
        let blob = new Blob([response.data])
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let date1 = new Date(this.date_start*1000)
        let date2 = new Date(this.date_end*1000)
        link.download = 'Traffic' + '_' + this.dev_id + '_' + date1.getDate() + '.' + (date1.getMonth() + 1) + '.' + date1.getFullYear() + '—' + ((+date2 !== 0) ? + date2.getDate() + '.' + (date2.getMonth() + 1) + '.' + date2.getFullYear() : '') + '.csv'
        link.click()
        this.loading = false
      })
    },

    get_traffic () {
      if (this.$route.name === 'device_section') {
        this.show = false
        this.noData = false
        let params = {
          ...this.filters,
          start: this.date_start,
          end: this.date_end,
          csv: false,
        }
        this.$http.v1.getDeviceTraffic(this.dev_id, params, (response) => {
          this.show = true
          if (Object.keys(response.data.ifaces).length === 0 &&
              Object.keys(response.data.simcards).length === 0 &&
              Object.keys(response.data.traffic).length === 0
          ) {
            this.noData = true
            return
          }

          let th = []
          let iface = []

          let name_iface = []

          for( let i in response.data.ifaces) {
              name_iface.push(i);
          }

          name_iface.sort();

          for (let i in name_iface) {
            th.push({type: 0, name: name_iface[i]})
            iface.push(name_iface[i])
          }

          let simcard_list = Object.values(response.data.simcards).sort((a, b) => a.slot > b.slot ? 1 : -1)

          for (let simcard of simcard_list) {
            let sim_info = {
              ...simcard,
              type: 1,
              name: simcard.mno
            }

            if (this.find_sim_by_imsi(simcard.imsi)?.sim_state) {
              sim_info.color = this.find_sim_by_imsi(simcard.imsi).sim_state.color
            }

            th.push(sim_info)
            iface.push(simcard.imsi)
          }

          this.th = th

          let tr = []
          let tdDate = []
          let td = []

          let traffics = Object.keys(response.data.traffic).sort()

          for (let key in this.total) {
              let ind = traffics.indexOf(this.total[key]);
              if (ind){
                  traffics.splice(ind,1)
              }
          }

          traffics = traffics.concat(this.total)

          for (let i in traffics) {
            td = []
            tdDate.push(traffics[i])
            td.push(traffics[i])
            for (let j in iface) {
              if ((response.data.traffic[traffics[i]] !== null && response.data.traffic[traffics[i]][iface[j]] !== undefined)) {
                td.push((+response.data.traffic[traffics[i]][iface[j]].rx).toFixed(2))
                td.push((+response.data.traffic[traffics[i]][iface[j]].tx).toFixed(2))
                td.push((response.data.traffic[traffics[i]][iface[j]].sum).toFixed(2))
              } else {
                td.push('null')
                td.push('null')
                td.push('null')
              }
            }
            tr.push(td)
          }
          this.tr = tr
        })
      }
    }
  }
}

</script>

<style lang='scss' scoped>

.response_table3{
  &::-webkit-scrollbar{
    height: 10px;
    width: 10px;
  }
  .title{
    font-size: 12px;
    line-height: 120%;
    font-weight: bold;
  }


  td, th{
    padding: 6px 4px;
  }
  table{
    tbody{
      .summary{
        td{
          background-color: #ddd;
          &:first-child{
            background-color: #ddd;
          }
        }
      }
      .min, .max, .average{
        td{
          background-color: #fff;
          &:first-child{
            background-color: #ddd;
          }
        }
      }
    }
  }
}
.traffic_block{
  div{
    display: flex;
    justify-content: center;
    align-items: center;
    span{
      margin: 0 3px;
    }
    .mdi{
      font-size: 16px;
    }
  }

}

.scale-loader {
  height: 9px;
  width: 9px;
  margin: 4px;
}

.card-traffic {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  .traffic_datepicker {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin: 10px 0;
    & > *{
      flex: 1;
      margin-bottom: 10px;
    }

    .form-group{
      min-width: 300px;
      margin-right: 10px;
    }

    .btn{
      min-height: 40px;
      margin-right: 10px;
      :last-child{
        margin-right: 0;
      }
      span{
        white-space: pre-line;
      }
    }
    .select{
      flex: 2;
      margin-right: 10px;
    }
    .filter{
      &.checkbox{
        margin: 0;
      }
    }
  }
}

@media (max-width:768px){
  .card-traffic .traffic_datepicker{
    height: 50%;
    overflow-y: auto;
    overflow-x: hidden;

    & > *{
      flex: auto;
      margin-bottom: 10px;
    }
    .btn{
      margin-right: 0;
    }

    .form-group{
      width: 100%;
      margin-right: 0;
    }
  }
}

@media (max-width:550px){
  .card-traffic .traffic_datepicker{
    flex-wrap: wrap;
    justify-content: center;

    & > *{
      margin-right: 0;
    }

    .form-group{
      width: 100%;
    }
    button{
      width: 100%;
    }
  }
}
 </style>
